import styled from 'styled-components';

export const AboutContainer = styled.div`
  width: 100%;
`;

export const AboutHero = styled.section`
  background: linear-gradient(rgba(34, 139, 34, 0.8), rgba(34, 139, 34, 0.8)),
              url('/about-hero.jpg') center/cover;
  padding: 100px 0;
  color: white;
  text-align: center;
`;

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

export const PageTitle = styled.h1`
  font-size: 3rem;
  font-weight: 700;
  margin-bottom: 20px;
  
  @media (max-width: 768px) {
    font-size: 2.5rem;
  }
`;

export const PageSubtitle = styled.p`
  font-size: 1.3rem;
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
`;

export const AboutContent = styled.section`
  padding: 80px 0;
  background: #f8f9fa;
`;

export const AboutGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;
  margin-bottom: 80px;
  
  @media (max-width: 968px) {
    grid-template-columns: 1fr;
    gap: 40px;
  }
  
  &:nth-child(even) {
    .about-text {
      order: 2;
    }
    .about-image {
      order: 1;
    }
  }
  
  @media (max-width: 968px) {
    &:nth-child(even) {
      .about-text {
        order: 1;
      }
      .about-image {
        order: 2;
      }
    }
  }
`;

export const AboutText = styled.div`
  h2 {
    font-size: 2.2rem;
    color: #228B22;
    margin-bottom: 20px;
    font-weight: 600;
  }
  
  p {
    font-size: 1.1rem;
    line-height: 1.7;
    color: #555;
    margin-bottom: 20px;
  }
  
  ul {
    list-style: none;
    padding: 0;
    
    li {
      font-size: 1.1rem;
      color: #555;
      margin-bottom: 10px;
      padding-left: 25px;
      position: relative;
      
      &:before {
        content: '✓';
        position: absolute;
        left: 0;
        color: #228B22;
        font-weight: bold;
      }
    }
  }
`;

export const AboutImage = styled.div`
  img {
    width: 100%;
    height: 400px;
    object-fit: cover;
    border-radius: 12px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  }
`;

export const ValuesSection = styled.section`
  padding: 80px 0;
  background: white;
`;

export const SectionTitle = styled.h2`
  text-align: center;
  font-size: 2.5rem;
  color: #333;
  margin-bottom: 20px;
  font-weight: 700;
  
  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

export const SectionSubtitle = styled.p`
  text-align: center;
  font-size: 1.2rem;
  color: #666;
  margin-bottom: 60px;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.6;
`;

export const ValuesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 40px;
  margin-top: 60px;
`;

export const ValueCard = styled.div`
  background: white;
  padding: 40px 30px;
  border-radius: 12px;
  text-align: center;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  border-top: 4px solid #228B22;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15);
  }
`;

export const ValueIcon = styled.div`
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #8B4513 0%, #A0522D 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
  color: white;
  font-size: 2rem;
`;

export const ValueTitle = styled.h3`
  font-size: 1.4rem;
  color: #333;
  margin-bottom: 15px;
  font-weight: 600;
`;

export const ValueDescription = styled.p`
  color: #666;
  line-height: 1.6;
  font-size: 1rem;
`;

export const StatsSection = styled.section`
  background: linear-gradient(135deg, #228B22 0%, #32CD32 100%);
  color: white;
  padding: 80px 0;
`;

export const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 40px;
  text-align: center;
`;

export const StatItem = styled.div`
  h3 {
    font-size: 3rem;
    font-weight: 700;
    margin-bottom: 10px;
    color: #E8F5E8;
  }
  
  p {
    font-size: 1.1rem;
    opacity: 0.9;
  }
`;

// Special sections with colored backgrounds
export const MissionVisionSection = styled.section`
  background: linear-gradient(135deg, #2E8B57 0%, #3CB371 100%);
  color: white;
  padding: 80px 0;
  margin: 80px 0;
  
  h2 {
    font-size: 2.5rem;
    color: white;
    margin-bottom: 30px;
    font-weight: 700;
    text-align: center;
  }
  
  p {
    font-size: 1.2rem;
    line-height: 1.8;
    margin-bottom: 25px;
    text-align: center;
    max-width: 800px;
    margin-left: auto;
    margin-right: auto;
    
    strong {
      color: #E8F5E8;
      font-weight: 600;
    }
  }
  
  @media (max-width: 768px) {
    padding: 60px 0;
    margin: 60px 0;
    
    h2 {
      font-size: 2rem;
    }
    
    p {
      font-size: 1.1rem;
      padding: 0 20px;
    }
  }
`;

export const LoadingSpinner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  width: 100%;
  
  .spinner {
    font-size: 3rem;
    color: #2E8B57;
    animation: spin 1s linear infinite;
  }
  
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

export const WhatSetsUsApartSection = styled.section`
  background: linear-gradient(135deg, #8B4513 0%, #CD853F 100%);
  color: white;
  padding: 80px 0;
  margin: 80px 0;
  
  h2 {
    font-size: 2.5rem;
    color: white;
    margin-bottom: 30px;
    font-weight: 700;
    text-align: center;
  }
  
  p {
    font-size: 1.2rem;
    line-height: 1.8;
    margin-bottom: 30px;
    text-align: center;
    max-width: 800px;
    margin-left: auto;
    margin-right: auto;
  }
  
  ul {
    list-style: none;
    padding: 0;
    max-width: 600px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 20px;
    
    li {
      font-size: 1.1rem;
      margin-bottom: 15px;
      padding: 20px;
      background: rgba(255, 255, 255, 0.1);
      border-radius: 8px;
      position: relative;
      backdrop-filter: blur(10px);
      border: 1px solid rgba(255, 255, 255, 0.2);
      transition: all 0.3s ease;
      
      &:hover {
        background: rgba(255, 255, 255, 0.15);
        transform: translateY(-2px);
      }
      
      &:before {
        content: '✓';
        position: absolute;
        left: -10px;
        top: 50%;
        transform: translateY(-50%);
        background: #F4A460;
        color: #8B4513;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        font-size: 0.9rem;
      }
    }
  }
  
  @media (max-width: 768px) {
    padding: 60px 0;
    margin: 60px 0;
    
    h2 {
      font-size: 2rem;
    }
    
    p {
      font-size: 1.1rem;
      padding: 0 20px;
    }
    
    ul {
      grid-template-columns: 1fr;
      padding: 0 20px;
      
      li {
        padding: 15px;
        font-size: 1rem;
      }
    }
  }
`;
